module.exports = __webpack_public_path__ + "static/cluster-234c375b1c86a4f819129cffe7c98d48.png";